(function () {
    'use strict';

    angular
        .module('telestatApp')
        .controller('HistoryLoaderController', HistoryLoaderController);

    HistoryLoaderController.$inject = ['$locale'];

    function HistoryLoaderController($locale) {
        var vm = this;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.dateformat = $locale.DATETIME_FORMATS.shortDate;

        vm.startTime = new Date();
        vm.endTime = new Date();
        vm.limit = 1000;
        vm.startTime.setDate(vm.endTime.getDate()-1);
        vm.datePickerOpenStatus.startTime = false;
        vm.datePickerOpenStatus.endTime = false;
        vm.historyProviderSelector = 'Megafon';

        vm.retransmissionStartTime = new Date();
        vm.retransmissionEndTime = new Date();
        vm.retransmissionStartTime.setDate(vm.retransmissionEndTime.getDate()-1);
        vm.datePickerOpenStatus.retransmissionStartTime = false;
        vm.datePickerOpenStatus.retransmissionEndTime = false;
        vm.retransmissionHistoryProviderSelector = 'Megafon';

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

    }

})();
